import { Icon24Refresh } from '@vkontakte/icons';

interface Props {
  className?: string;
  onClick?: () => void;
}

export const RetryFileButton = ({ className, onClick }: Props) => {
  return (
    <div className={className} onClick={onClick}>
      <Icon24Refresh />
    </div>
  );
};
